import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
import { Pagination } from '../../../models/pagination';
import { CompaniesService } from '../../../services/companies.service';
import { Client } from '../../../models/client';
import { ClientSelected } from '../../../state/ClientSelectionState/ClientSelection.state';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-client-search',
  templateUrl: './client-search.component.html',
  styleUrls: ['./client-search.component.css'],
  standalone: false
})
export class ClientSearchComponent implements OnInit {
  clients: Client[];
  minSearchLength = 2;
  pagination: Pagination;
  searchQuery = '';

  constructor(
    public companyService: CompaniesService,
    public route: ActivatedRoute,
    private store: Store
  ) {
    this.search = _.debounce(this.search, 250);
  }

  loadPage({ Page }: Pagination) {
    this.companyService
      .searchCompanies({ query: this.searchQuery, pageNumber: Page })
      .subscribe(resp => {
        this.clients = resp.Items;
        this.pagination = resp.Pagination;
      });
  }

  ngOnInit() {
    this.searchQuery = this.route.snapshot.paramMap.get('search_query');

    if (this.searchQuery) {
      this.search();
    }
  }

  search() {
    if (!this.searchQuery || this.searchQuery.length < this.minSearchLength) {
      this.clients = [];
    } else {
      this.companyService.searchCompanies({ query: this.searchQuery }).subscribe(data => {
        if (data && data.Items) {
          this.clients = data.Items;
          this.pagination = data.Pagination;
        } else {
          this.clients = [];
        }
      });
    }
  }

  navigateToClient(clientCode) {
    this.store.dispatch(new ClientSelected(clientCode)).subscribe(_ => {
      this.store.dispatch(new Navigate([`/client/${clientCode}`]));
    });
  }
}
